module.exports = __webpack_public_path__ + "static/desktopHero-703ed1e80760244c3f9d297939355580.png";